// The docs page routes' `head`. Apart from DocsPageView: a route's `head` stays in the router's
// entry chunk, while its component is split into the page's own chunk.
import { getDocsPageMetadata } from "src/lib/DocsPages";
import { metadataHead } from "src/lib/Metadata";
import type { getDocsPage } from "src/server/functions/DocsPage";

export type DocsPageData = Awaited<ReturnType<typeof getDocsPage>>;

export const docsPageHead = ({ loaderData }: { loaderData?: DocsPageData }) =>
  loaderData ? metadataHead(getDocsPageMetadata(loaderData)) : {};
